import { I18n } from '@front/volcanion'

class Callbacks {
  static onConfirmResetIdentifierHandler(resetIdentifiers, openNotification, setFormValues, isReadOnly, record_id) {
    return async function onConfirmResetIdentifier() {
      try {
        const [companyuser] = await resetIdentifiers({ companyuser_id: record_id })
        !isReadOnly && setFormValues([
          { field: 'identifier', value: companyuser?.identifier },
          { field: 'pin', value: companyuser?.pin }
        ])
        openNotification(I18n.t('identifier.reset.success'), { variant: 'success' })
      } catch (error) {
        openNotification(I18n.t('identifier.reset.error'), { variant: 'error' })
      }
    }
  }
}

export default Callbacks
